module.exports = "<p>\n  nueva-causa works!\n</p>\n"